// https://chatgpt.com/share/681f8784-e434-8011-adb3-f807a593a6c3
/* пример:
<template data-delay="10">
	<script src="<?=TPL?>/src/js/notiflow.js"></script>
</template>
*/
document.addEventListener("DOMContentLoaded", () => {
	const templates = document.querySelectorAll('template')

	templates.forEach(tpl => {
		const { delay: delayAttr, src, init: initCode } = tpl.dataset
		const delay = delayAttr ? parseInt(delayAttr, 10) : NaN

		if (initCode) {
			try {
				new Function(initCode)()
			} catch (err) {
				console.error('Ошибка выполнения data-init:', err)
			}
		}

		// проверяем, есть ли в шаблоне непустой контент
		const hasContent = Array.from(tpl.content.childNodes).some(node =>
			node.nodeType === Node.ELEMENT_NODE ||
			node.nodeType === Node.TEXT_NODE && node.textContent.trim()
		)

		// 3) и 2) data-src (+ возможный delay)
		if (src && !isNaN(delay)) {
			setTimeout(() => {
				placeHTML(src)
			}, delay)

		} else if (src) placeHTML(src)

		// 1) только data-delay + непустой контент
		else if (!isNaN(delay) && hasContent) {
			setTimeout(() => {
				const parent = tpl.parentNode
				const clone = document.importNode(tpl.content, true)
				parent.replaceChild(clone, tpl)
			}, delay)
		}
	})
})